export default __webpack_public_path__ + "static/endless128-338d37c1688d7d803776a046f14cce11.png";